import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  showError(textOrTpl: string, options: any = {}) {
    this.toasts.push({
      textOrTpl: textOrTpl,
      className: 'bg-danger text-light',
      iconClassName: 'fas fa-exclamation-triangle fa-lg',
      ...options
    });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  clear() {
    this.toasts.length = 0;
  }
}
